import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubcategoryGrid from '../components/Paint/SubcategoryGrid';

const slugToLabel = (s) => {
  if (!s) return '';
  const map = [
    'Mastics / Putties',
    'Degreasers',
    'Abrasives',
    'Fillers / Apprêts',
    'Ready Mix / Finished Paint',
    'Masking Products',
    'Primers',
    'Stone Chip Protectors',
    'Miscellaneous / Accessories',
    'Varnishes / Clearcoats',
    'Sealants',
    'Paint Equipment / Tools',
    'Thinners / Reducers',
    'Spray Products / Aerosols',
    'Base Coats (Color Mixing System)',
  ];
  const normalized = s.toLowerCase();
  const unslug = normalized
    .replace(/-/g, ' ')
    .replace(/\bpaints?\b/g, '')
    .trim();
  const candidate = map.find((label) => {
    const lslug = label
      .toLowerCase()
      .replace(/\s*\(.*?\)\s*/g, '')
      .replace(/\s*\/\s*/g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .trim();
    return lslug === normalized;
  });
  if (candidate) return candidate;
  const loose = map.find((label) => label.toLowerCase().includes(unslug));
  return loose || s;
};

const PaintSubcategory = () => {
  const { t } = useTranslation();
  const { subcategory } = useParams();
  const label = useMemo(() => slugToLabel(subcategory), [subcategory]);
  const [title, setTitle] = useState(label);
  useEffect(() => setTitle(label), [label]);

  return (
    <section className="w-full px-4 sm:px-6 xl:px-8 pt-24 sm:pt-28 pb-20 sm:pb-[90px] mb-20 md:mb-[120px]">
      <div className="max-w-[1350px] w-full mx-auto">
        <h1 className="text-center libre-baskerville font-normal text-[32px] md:text-[56px] leading-[40px] md:leading-[81px] text-[#1D1D1F]">
          {t(`categories.${title}`, title)}
        </h1>
        <div className="mt-10">
          <SubcategoryGrid subcategory={label} />
        </div>
      </div>
    </section>
  );
};

export default PaintSubcategory;
